/** Session-scoped key for back-navigation restore. Scoped by tenant+user to prevent cross-tenant bleed. */
export function getOmnisearchSessionKey(tenantId: string, userEmail: string): string {
  return `wasteSubmissionsOmnisearch|${tenantId}|${userEmail}`;
}

/** LocalStorage key for cross-session persistence. Scoped by tenant+user to prevent cross-tenant bleed. */
export function getOmnisearchStorageKey(tenantId: string, userEmail: string): string {
  return `waste-submissions-last-omnisearch|${tenantId}|${userEmail}`;
}

export function getWasteSubmissionsUrl(tenantId: string, omnisearch?: string | null): string {
  if (!omnisearch) {
    return `/o/${tenantId}/waste/submissions`;
  }

  return `/o/${tenantId}/waste/submissions?omnisearch=${encodeURIComponent(omnisearch)}`;
}

export function getSavedWasteSubmissionsUrl(tenantId: string, userEmail?: string): string {
  if (!userEmail) {
    return getWasteSubmissionsUrl(tenantId);
  }
  const savedOmnisearch =
    sessionStorage.getItem(getOmnisearchSessionKey(tenantId, userEmail)) ??
    localStorage.getItem(getOmnisearchStorageKey(tenantId, userEmail));
  return getWasteSubmissionsUrl(tenantId, savedOmnisearch);
}
